export const getAllPreview = ( state) => {
    return state.all
}